/**
 *   Created by ATopcu in 2019
 */

export default class PivotFilterDefinition {
  #incExclude;
  #level;
  #values;

  constructor({ includeExclude, level, values }) {
    this.#incExclude = includeExclude;
    this.#level = level;
    this.#values = values;
  }

  copy = () => {
    return {
      includeExclude: this.includeExclude,
      level: this.level,
      values: this.values,
    };
  };

  get includeExclude() {
    return this.#incExclude;
  }

  setIncludeExclude = (value) =>
    new PivotFilterDefinition({
      ...this.copy(),
      includeExclude: value,
    });

  get level() {
    return this.#level;
  }

  setLevel = (value) =>
    new PivotFilterDefinition({
      ...this.copy(),
      level: value,
    });

  get values() {
    return this.#values;
  }

  setValues = (value) =>
    new PivotFilterDefinition({
      ...this.copy(),
      values: value,
    });

  get key() {
    return [this.includeExclude, this.level, this.values.join(",")].join(",");
  }

  get filterTypeParameter() {
    return `${this.level},${this.includeExclude}`;
  }

  get filterParameter() {
    return `${this.level},${this.values.join(",")}`;
  }

  static filterTypeParameter(definitions) {
    return definitions?.map((def) => def.filterTypeParameter).join(";"); // GS specs
  }

  static filtersParameter(definitions) {
    return definitions?.map((def) => def.filterParameter).join(";"); // GS specs
  }
}
